import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  
  constructor(private http: HttpClient, private languageService: LanguageService) {}

  get() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}setting?lang=${lang}`);
  }


  update(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/update/setting?lang=${lang}`, data);
  }
  
}